// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import Button from "react-bootstrap/Button";
import Translate from "react-translate-component";
import "./Footer.css";
class Footer extends Component {
  render() {
    return (
      <div className="footer-container">
        <div className="contact text-center">
          <div className="container">
            <div className="row">
              <div className="column_container col-sm-12 col-lg-8 col-md-8 col-xs-12">
                <Translate content="footer.mainFooter.title" component="h2" />
                <Translate content="footer.mainFooter.desc" component="p" />
                <Button variant="outline-light">
                  <Translate content="footer.mainFooter.btn" />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="container">
            <div className="float-left">
              <Translate content="footer.subFooter.copyRights" unsafe={true} />
            </div>
            <div className="float-right">
              <span className="phone">+001 234 56 78</span>
              <span className="email">hello@dream-theme.com</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
